// ----------------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ---------------------------------------------------------------------
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { InstrumentService } from '../core/instrument';
import { StaticProvider } from '../providers/staticProvider';
import { SharedTelemetryService } from './sharedTelemetry';
import * as appConfig from '../../init/appConfig';
export class SharedInstrumentService extends InstrumentService {
    static getInstance() {
        if (SharedInstrumentService._instance === null) {
            const isClient = appConfig.get('runtimeEnvironment') === 'browser';
            SharedInstrumentService._instance = new SharedInstrumentService(isClient);
        }
        return SharedInstrumentService._instance;
    }
    static getProvider() {
        return SharedInstrumentService.getInstance().getProvider('shared');
    }
    constructor(isClient){
        if (SharedInstrumentService._instance) {
            throw new Error('Error : Instantiation failed. Use SharedInstrumentService.getInstance');
        } else {
            super(), _define_property(this, "staticProvider", void 0), _define_property(this, "telemetryService", void 0);
            this.name = 'SharedInstrument';
            this.staticProvider = new StaticProvider('shared', this);
            this.telemetryService = new SharedTelemetryService(this, isClient);
            SharedInstrumentService._instance = this;
        }
    }
}
_define_property(SharedInstrumentService, "_instance", null);
